import { render, staticRenderFns } from "./AdminRespuestas.vue?vue&type=template&id=41a0814a"
import script from "./AdminRespuestas.vue?vue&type=script&lang=js"
export * from "./AdminRespuestas.vue?vue&type=script&lang=js"
import style0 from "./AdminRespuestas.vue?vue&type=style&index=0&id=41a0814a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports